import React from "react";
import * as Api from "api/api";

import * as Form from 'tsui/Form';
import { ApiCard } from "api";
import { Box, FormControl, InputLabel, MenuItem, Radio, Select, SelectChangeEvent, Switch } from "@mui/material";
import { styled as muiStyled } from '@mui/system';
import { useTranslation } from "react-i18next";
import session_ from 'api/session';

const ImageComponent = muiStyled('img')({});


interface IssuedCardDetailsProps {
    onClose: () => void;
    cardId: string;

}


const label = { inputProps: { 'aria-label': 'Switch demo' } };


export default function IssuedCard(props: IssuedCardDetailsProps) {
    const form = Form.useInputForm();
    const [data, setData] = React.useState<ApiCard | null>(null);
    const [templateName, setTemplateName] = React.useState('card_design_template1');
    const templateNameRef = React.useRef('card_design_template1')
    const [t] = useTranslation();
    const [currentLang, setCurrentLang] = React.useState(session_.lang);
    const [swtichonOff, setSwtichonOff] = React.useState('off');
    const swtichonOffRef = React.useRef('off')


    const handleTemplateChange = (event: SelectChangeEvent) => {
        setTemplateName(event.target.value);
        templateNameRef.current = event.target.value;
    };

    const handleSwitchOnChange = (event: SelectChangeEvent) => {
        setSwtichonOff(event.target.value);
        swtichonOffRef.current = event.target.value;
        console.log('swtichonOffRef', swtichonOffRef.current)
    };

    const buttonRef = React.useRef<HTMLButtonElement>();

    const onSubmit = React.useCallback((evt: Form.InputFormEvent) => {

        evt.data.cardId = props.cardId
        console.log('evt.data.cardId', evt.data.cardId)

        Api.requestSessionJson<any>('orders', 'issued_card', { cardId: props.cardId, issuedCard: swtichonOffRef.current }, {}).then(d => {
            // console.log('ddddddddddddddd', JSON.stringify(d))

            // setHtmlPreview(JSON.stringify(d))

            props.onClose();

        }).catch(err => console.log(err));
        props.onClose();

    }, []);

    // console.log('template NAME Out of onSubmit', templateName)

    // TODO: remove in the future
    // return <></>

    return <Form.PageFormDialog title='Card Issue' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>


        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <Select
                    value={swtichonOff}
                    onChange={handleSwitchOnChange}
                >
                    <MenuItem key='on' value='on'>{t('on')}</MenuItem>
                    <MenuItem key='off' value='off'>{t('off')}</MenuItem>
                </Select>
            </FormControl>
        </Box>


    </Form.PageFormDialog>


}
